import { useState, useEffect } from "react";
import { Snackbar, Alert } from "@mui/material";
import WifiOffIcon from "@mui/icons-material/WifiOff";

const OfflineNotification = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <Snackbar
      open={!isOnline}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      sx={{
        top: { xs: 80, sm: 80 }, // Position consistent with other notifications
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1500, // Higher priority than standard notifications
        "& .MuiSnackbarContent-root": {
          width: "auto",
          minWidth: "300px",
          maxWidth: "600px",
        },
      }}
    >
      <Alert
        variant="filled"
        severity="error"
        icon={<WifiOffIcon fontSize="inherit" />}
        sx={{
          width: "100%",
          bgcolor: "primary.main", // Standard error color
          color: "white",
          "& .MuiAlert-icon": {
            color: "white",
          },
          "& .MuiAlert-message": {
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
        }}
      >
        You are offline. Please check your internet connection.
      </Alert>
    </Snackbar>
  );
};

export default OfflineNotification;
